/* TUSK: intercept custom Add-to-cart forms, add via AJAX and open Dawn's cart drawer.
   Falls back to a normal form submit if anything is unavailable or errors. */
(function () {
  var SELECTOR = '.tusk-pdp__form, .tusk-reveal__form';

  function getCartDrawer() {
    var el = document.querySelector('cart-drawer');
    if (el && typeof el.renderContents === 'function') return el;
    return null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form) return;

    var cartDrawer = getCartDrawer();
    if (!cartDrawer) return; // no drawer (e.g. notification mode) → let the form submit normally

    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.append('quantity', 1);

    var ids = ['cart-drawer', 'cart-icon-bubble'];
    if (typeof cartDrawer.getSectionsToRender === 'function') {
      try { ids = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (err) {}
    }
    formData.append('sections', ids.join(','));
    formData.append('sections_url', window.location.pathname);

    if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('loading'); }

    var addUrl = (window.routes && window.routes.cart_add_url)
      ? window.routes.cart_add_url
      : (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add' : '/cart/add');

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { form.submit(); return; } // 422 etc. → fall back to the cart page
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(res);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('loading'); }
      });
  });
})();
